import { logger } from './logger';

/**
 * Production-safe logging utilities
 * These functions handle logging appropriately for production environments
 */

export const logDebug = (message: string, data?: any) => {
  // Only log in development
  if (process.env.NODE_ENV === 'development') {
    logger.debug(message, data);
  }
};

export const logInfo = (message: string, data?: any) => {
  logger.info(message, data);
};

export const logWarning = (message: string, data?: any) => {
  logger.warn(message, data);
};

export const logError = (message: string, error?: any) => {
  // Always log errors, but sanitize for production
  const sanitizedError = error instanceof Error 
    ? { message: error.message, name: error.name }
    : error;
  
  logger.error(message, sanitizedError);
};

// Silent operations for production (no-op logging)
export const silentLog = () => {};
export const silentError = () => {};
export const silentWarn = () => {};